// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3eVKI","modalForm":"UpgradeEpcsModal_modalForm__ygJ4Z","modalFooter":"UpgradeEpcsModal_modalFooter__1F_Tt"};